import { useForm } from '@mantine/form';
import { useState } from 'react';
import { validateNumber } from '../../../util/validation/commonValidation';
import type { BulkUpsertProductPriceDto } from '../types/ProductPriceDto';

const defaultBulkUpsertProductPriceDto: BulkUpsertProductPriceDto = {
	incVatPrice: undefined,
	stockLevel: undefined,
	keys: [],
	allSelected: false,
};

export function useBulkUpsertProductPriceForm(
) {
	const [inputs, setInputs] = useState<BulkUpsertProductPriceDto>(defaultBulkUpsertProductPriceDto);

	const form = useForm<BulkUpsertProductPriceDto>({
		mode: 'uncontrolled',
		initialValues: inputs,
		validate: {
			incVatPrice: (v) =>
				validateNumber(v?.toString(), true, 0, 1000000, 'Price inc. VAT'),
			stockLevel: (value) =>
				validateNumber(
					value?.toString(),
					true,
					0,
					10000000,
					'Stock Level',
					false,
				),
		},
		onValuesChange: (v) => setInputs(v),
	});

	return { form, inputs };
}